import { useState } from 'react';
import { Page } from '../../components/page.tsx';
import { CasesPanel } from './cases.tsx';
import { RunsPanel } from './runs.tsx';
import { TestAccountsPanel } from './test-accounts.tsx';

const TABS = [
  { id: 'cases', label: 'Cases' },
  { id: 'runs', label: 'Runs' },
  { id: 'accounts', label: 'Test accounts' },
] as const;
type Tab = (typeof TABS)[number]['id'];

export function EvaluationsSection() {
  const [tab, setTab] = useState<Tab>('cases');
  const [openRun, setOpenRun] = useState<string | null>(null);
  return (
    <Page
      title="Evaluations"
      summary="Questions your users ask, with what a good answer must do. Each case runs three times and passes only if a judge passes all three answers."
    >
      <div className="row" role="tablist" aria-label="Evaluations">
        {TABS.map((entry) => (
          <button
            key={entry.id}
            type="button"
            role="tab"
            aria-selected={tab === entry.id}
            className={tab === entry.id ? 'primary' : 'quiet'}
            onClick={() => setTab(entry.id)}
          >
            {entry.label}
          </button>
        ))}
      </div>
      {tab === 'cases' && (
        <CasesPanel
          onRunStarted={(runId) => {
            setOpenRun(runId);
            setTab('runs');
          }}
        />
      )}
      {tab === 'runs' && <RunsPanel openRun={openRun} onOpenRun={setOpenRun} />}
      {tab === 'accounts' && <TestAccountsPanel />}
    </Page>
  );
}
